// extracted by mini-css-extract-plugin
export var dBlock = "portfolio-detail-module--d-block--30015";
export var dFlex = "portfolio-detail-module--d-flex--5c931";
export var dInline = "portfolio-detail-module--d-inline--452a1";
export var dLgBlock = "portfolio-detail-module--d-lg-block--47a0e";
export var dLgFlex = "portfolio-detail-module--d-lg-flex--55394";
export var dLgInline = "portfolio-detail-module--d-lg-inline--6a0ab";
export var dLgNone = "portfolio-detail-module--d-lg-none--bdc47";
export var dMdBlock = "portfolio-detail-module--d-md-block--f92ea";
export var dMdFlex = "portfolio-detail-module--d-md-flex--b1301";
export var dMdNone = "portfolio-detail-module--d-md-none--3846c";
export var dNone = "portfolio-detail-module--d-none--07af4";
export var detailArrow = "portfolio-detail-module--detail-arrow--c78c3";
export var detailAssetImage = "portfolio-detail-module--detail-asset-image--9d19d";
export var detailBody = "portfolio-detail-module--detail-body--31a79";
export var detailBodyDragging = "portfolio-detail-module--detail-body-dragging--d9a3e";
export var detailCreditsCol = "portfolio-detail-module--detail-credits-col--c9fc1";
export var detailDescription = "portfolio-detail-module--detail-description--c8aa8";
export var detailGalleryAnchor = "portfolio-detail-module--detail-gallery-anchor--170fe";
export var detailHeader = "portfolio-detail-module--detail-header--81247";
export var detailHeaderTitle = "portfolio-detail-module--detail-header-title--5fc7e";
export var detailImageCol = "portfolio-detail-module--detail-image-col--9c55e";
export var detailImageColLead = "portfolio-detail-module--detail-image-col-lead--cfc1d";
export var detailLeadTilt = "portfolio-detail-module--detail-lead-tilt--8439f";
export var detailMainImage = "portfolio-detail-module--detail-main-image--ea596";
export var detailPage = "portfolio-detail-module--detail-page--f94c2";
export var detailQuote = "portfolio-detail-module--detail-quote--563b7";
export var detailStatementItem = "portfolio-detail-module--detail-statement-item--c1b20";
export var detailStatementNumber = "portfolio-detail-module--detail-statement-number--8f9e3";
export var detailStatementText = "portfolio-detail-module--detail-statement-text--d5964";
export var detailStatements = "portfolio-detail-module--detail-statements--dc48a";
export var detailStatementsCol = "portfolio-detail-module--detail-statements-col--a4aa5";
export var detailSubtitle = "portfolio-detail-module--detail-subtitle--29fa2";
export var detailTextCol = "portfolio-detail-module--detail-text-col--b45bf";
export var detailTitle = "portfolio-detail-module--detail-title--43a03";
export var detailTitleRow = "portfolio-detail-module--detail-title-row--747d1";
export var galleryItem = "portfolio-detail-module--gallery-item--c2a77";
export var galleryItemActive = "portfolio-detail-module--gallery-item-active--5174a";
export var galleryLabel = "portfolio-detail-module--gallery-label--717e9";
export var galleryStrip = "portfolio-detail-module--gallery-strip--2627b";
export var galleryThumb = "portfolio-detail-module--gallery-thumb--8bcf1";
export var portfolioGalleryAnchor = "portfolio-detail-module--portfolio-gallery-anchor--f370b";
export var portfolioGalleryPersistentHost = "portfolio-detail-module--portfolio-gallery-persistent-host--0fcfe";